var trim = function (input) { return input.trim(); };
export default trim;
